<template>
  <span v-if="session?.foreigner" class="badge bg-info-soft"
    ><i class="fa-solid fa-clock me-1"></i>
    <span v-if="icon">
      {{ LanguagesObj["pt-br"].flag }}
    </span>
    <span v-else>Horário de Brasília</span>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useSessionStore } from "../store/useSessionStore";
import LanguagesObj from "../utils/LanguagesObj";

const session = computed(() => useSessionStore().session);

const { icon } = defineProps<{ icon?: boolean }>();
</script>
